import type { AdminUser } from '../types/admin';

const FACE_LIVENESS_TYPES = [
  'FACE_LIVENESS_RIGHT',
  'FACE_LIVENESS_LEFT',
  'FACE_LIVENESS_STRAIGHT',
] as const;

export type AdminOnboardingStage =
  | 'verify-email'
  | 'phone-verification'
  | 'face-liveness'
  | 'completed';

function hasFaceLivenessPack(user: AdminUser): boolean {
  const attachments = user.attachments ?? {};
  const values = Object.values(attachments);

  return (
    values.some((attachment) =>
      FACE_LIVENESS_TYPES.includes(
        String(attachment?.fileType ?? '') as (typeof FACE_LIVENESS_TYPES)[number],
      ),
    ) ||
    Object.keys(attachments).some((key) =>
      FACE_LIVENESS_TYPES.includes(key as (typeof FACE_LIVENESS_TYPES)[number]),
    )
  );
}

export function nextStageForAdmin(user: AdminUser | null): AdminOnboardingStage {
  if (!user) return 'verify-email';

  if (user.emailVerified === false) {
    return 'verify-email';
  }

  if (!user.phoneVerified) {
    return 'phone-verification';
  }

  if (!hasFaceLivenessPack(user)) {
    return 'face-liveness';
  }

  return 'completed';
}
